/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Card_Abilities_AllInputs */



/**
* | output |
* | --- |
* | "Everything the chat offers" |
*
* @param {Agent_Wizard_Card_Abilities_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_card_abilities_all = /** @type {((inputs?: Agent_Wizard_Card_Abilities_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Card_Abilities_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles, was der Chat bietet")
	return /** @type {LocalizedString} */ ("Everything the chat offers")
});